import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { AuthShell } from "@/pages/auth/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { apiError } from "@/lib/api";

export default function Reset() {
  const [sp] = useSearchParams();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const token = sp.get("token");
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      nav("/login", { replace: true });
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };
  return (
    <AuthShell title="Set a new password" subtitle="Choose a strong password you'll remember."
      footer={<Link to="/login" className="font-semibold text-emerald-brand">Back to sign in</Link>}>
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <div>
          <Label className="font-semibold text-slate-600">New password</Label>
          <Input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" className="mt-1.5 h-11" placeholder="••••••••" />
        </div>
        <Button type="submit" disabled={loading || !token} data-testid="reset-submit-btn" className="w-full bg-[#0B223D] text-white font-bold h-12 rounded-xl">
          {loading ? "Updating…" : "Update password"}
        </Button>
      </form>
    </AuthShell>
  );
}
